module.exports = __webpack_public_path__ + "img/447.fb693387.png";